import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewStatusActions from './review-status.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewStatusStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewStatusActions.ReviewStatusRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_STATUS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewStatusActions.ReviewStatusCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewStatusActions.ReviewStatusUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewStatusActions.ReviewStatusDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewStatusActions.ReviewStatusRefresh());
          break;
      }
    });
  }
}
